module.exports = "label {\n    color: rgba(31, 112, 191, 0.9);\n}\n\n.Soustitre {\n    color: rgb(31, 112, 191);\n    font-weight: bold;\n    font-size: 18px;\n    margin-bottom: 0px;\n    margin-top: 2px;\n}\n\n.trait {\n    border-top: 2px solid rgb(31, 112, 191);\n    margin-top: 0px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/fiche-entretien/fiche-entretien.component.css
// module id = ./src/app/fiche-entretien/fiche-entretien.component.css
// module chunks = main